import { Relays } from 'constants/Relays';
import { GetRelay, SetRelay, useRelay } from 'phoenix/hooks/UseRelay';

export const useShowAmexCardModal = () => useRelay<boolean>(Relays.ShowAmexCardModal)
export const SetShowAmexCardModal = (isOpen: boolean) => SetRelay(Relays.ShowAmexCardModal, isOpen)
export const GetShowAmexCardModal = () => GetRelay(Relays.ShowAmexCardModal)